export default __webpack_public_path__ + "static/media/xls.aeedf24f.svg";